import type { JSX } from "react";
import type { Paper } from "@mui/material";
import { css, styled } from "@mui/material";
import { Outlet } from "react-router";
import { NavBar } from "../components/organisms/nav-bar/nav-bar";
import { NAV_ITEMS } from "./nav-items";


const MainContent = styled("div")(({ theme }) => css`
	padding-top: calc(${theme.layout.navBarHeight});
	min-height: 100vh;
	width: 100%;
	margin: 0 auto;
	overflow: unset;
`) as typeof Paper;

export const Page = (): JSX.Element => (
	<>
		<NavBar items={ NAV_ITEMS }/>
		<MainContent component="main" square>
			<Outlet/>
		</MainContent>
	</>
);